export default (item) =>
  !(
    item.his_treatment === 'Non traitee' &&
    item.status === '1' &&
    item.rejected === 'N'
  ) ||
  !(
    item.work_order_group_type_code === 1 &&
    (item.work_order_group_qualif_code === 9 ||
      item.work_order_group_qualif_code === 10 ||
      item.work_order_group_qualif_code === 178)
  ) ||
  true;
